import type { AlienMistakeEntry } from './types';

export const alienInvasionMistakes: AlienMistakeEntry[] = [
  {
    "id": "ai:mistake:invasion-endgame",
    "scenarioId": "invasion",
    "title": "Doliczanie punktów na końcu",
    "explanation": "W Invasion nie ma punktacji końcowej; zwycięstwo następuje natychmiast."
  },
  {
    "id": "ai:mistake:invasion-tech",
    "scenarioId": "invasion",
    "title": "Zapominanie o rozwoju technologii Obcych",
    "explanation": "Użycie technologii innego człowieka pozwala Dowódcy Obcych rozwinąć własną technologię."
  },
  {
    "id": "ai:mistake:outbreak-round1",
    "scenarioId": "outbreak",
    "title": "Dobieranie infekcji w rundzie 1",
    "explanation": "W rundzie 1 nie dobiera się kart infekcji na początku tur."
  },
  {
    "id": "ai:mistake:outbreak-spread",
    "scenarioId": "outbreak",
    "title": "Rozprzestrzenianie między wszystkimi kwaterami",
    "explanation": "Zakażenie przenosi się tylko w obrębie tego samego obszaru lub komórki."
  },
  {
    "id": "ai:mistake:blackout-state",
    "scenarioId": "blackout",
    "title": "Wyłączanie zdewastowanego budynku",
    "explanation": "Sam token Blackout oznacza wandalizm; budynek nadal działa, dopóki nie leży na nim kolonista."
  },
  {
    "id": "ai:mistake:monolith-phase",
    "scenarioId": "monolith",
    "title": "Pomijanie fazy sabotażu",
    "explanation": "Faza sabotażu występuje po kolonizacji i przed fazą wahadłowca."
  }
];
